// Just a shortcut for bulk export

import parseLinkLabel from './parse_link_label.mjs'
import parseLinkDestination from './parse_link_destination.mjs'
import parseLinkTitle from './parse_link_title.mjs'

export {
  parseLinkLabel,
  parseLinkDestination,
  parseLinkTitle
}
